// Keep this helper aligned in frontend/src/utilities and mobile_app/utilities.
// Center a new paid break in the longest remaining work segment.
export function getDefaultPaidBreakStart(shift, paidBreaks = [], duration = 10 / 60) {
  const start = shift?.shift_start;
  const end = shift?.shift_end;
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) {
    return null;
  }

  const occupied = [
    { start: shift.break_start, duration: shift.break_length },
    { start: shift.break_start_2, duration: shift.break_length_2 },
    ...paidBreaks.map((entry) => ({
      start: entry.break_start,
      duration: entry.break_duration || duration,
    })),
  ]
    .filter((entry) => Number.isFinite(entry.start) &&
      Number.isFinite(entry.duration) && entry.duration > 0)
    .map((entry) => ({
      start: Math.max(start, entry.start),
      end: Math.min(end, entry.start + entry.duration),
    }))
    .filter((entry) => entry.end > entry.start)
    .sort((a, b) => a.start - b.start);

  let cursor = start;
  let best = null;
  // A final boundary also considers the work after the last break.
  for (const entry of [...occupied, { start: end, end }]) {
    const length = entry.start - cursor;
    if (length >= duration - 1e-9 &&
        (!best || length > best.end - best.start + 1e-9)) {
      best = { start: cursor, end: entry.start };
    }
    cursor = Math.max(cursor, entry.end);
  }
  if (!best) return null;

  // Prefer a five-minute mark, clamped so rounding cannot overlap a break.
  const midpoint = (best.start + best.end - duration) / 2;
  return Math.max(best.start, Math.min(best.end - duration,
    Math.round(midpoint * 12) / 12));
}
